// ADDED
import React from "react";
import { CreateTableNew as CreateTable } from "../../../../../common/APICommon";
import EditIcon from '@mui/icons-material/Edit';
import { StatusBadge } from "../../../../../common/Badge";

const SalaryAdvanceAccessTable = ({
  data,
  onEdit,
  currentPage,
  setCurrentPage
}) => {
  const headers = [
    "ID",
    "Access Type",
    "Assignment Manager",
    "Preparer Manager",
    "Releasing Manager",
    "Actions"
  ];

  const accessors = [
    "id", 
    "description",
    "isSalaryAdvanceAssignmentManager",
    "isSalaryAdvancePreparerManager",
    "isSalaryAdvanceReleasingManager",
    "actions"
  ];

  const customCellRenderer = (row, accessor) => {
    const booleanFields = [
      "isSalaryAdvanceAssignmentManager",
      "isSalaryAdvancePreparerManager",
      "isSalaryAdvanceReleasingManager"
    ];

    if (booleanFields.includes(accessor)) {
      return <StatusBadge status={row[accessor] ? "Yes" : "No"} />;
    }
    return null;
  };

  const actions = [
    {
      name: "Edit",
      tooltip: "edit",
      icon: <EditIcon fontSize="small" />,
      className: "bg-green-500 hover:bg-green-600 flex items-center",
      function: onEdit,
      visible: true,
    },
  ];

  return (
    <CreateTable
      tableName={"Salary Advance Access List"}
      headers={headers}
      accessors={accessors}
      data={data}
      actions={actions}
      currentPage={currentPage}
      setCurrentPage={setCurrentPage}
      itemsPerPage={10}
      totalItems={data?.length}
      customCellRenderer={customCellRenderer}
    />
  );
};

export default SalaryAdvanceAccessTable;